export default class GetConvocatoriasBySubtipo {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idSubTipo) {
    try {
      const result = await this.#repository.getConvocatoriasBySubtipo(idSubTipo)
      return result
    } catch (error) {
      console.error('Error al obtener las convocatorias por subtipo:', error)
      throw error
    }
  }
}
